

































// @ is an alias to /src
import { AloBase } from '@/models/alo/AloBase';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'SearchDialog',  
  props: {
    title:String,
    libelle:String,
    extendHeader:{
      type:Array,
      default:()=>[]
    },
    search:{
      type:Function,
      required:true
    }
  }
})
export default class SearchDialog extends Vue {
  title!:string
  libelle!:string
  extendHeader!:Array<any>
  showDialog = false
  searchText = ""
  loading = false
  items:Array<AloBase> = [] 
  search!:(search:string)=>Promise<Array<AloBase>>

  private get headers() {
    return  [
      { text: 'ID', value: 'id', width:70 },    
      { text: this.libelle, value: 'libelle' },    
      ...this.extendHeader,
      { text: '', value:'actions', width:30, sortable:false,filterable:false}
    ]
  }

  show() {    
    this.items = []
    this.searchText = ""
    this.showDialog = true
  }

  select(item:AloBase) {
    this.$emit("select",item)  
    this.showDialog = false
  } 

  doSearch(){
    this.loading = true
    this.search(this.searchText).then(items => {
      this.items = items
    })
    .finally(()=>{
      this.loading = false
    })
  }

}
